import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RegistrationResults } from '../../interfaces/registration-results/registration-results';
import { LienDetailsUIConfiguration } from '../../interfaces/ui-configurations/lien-details-ui-configuration';
import { Order } from '../../interfaces/orders/order';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'lib-registration-results-static',
    templateUrl: './registration-results-static.component.html',
    styleUrl: './registration-results-static.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RegistrationResultsStaticComponent implements OnInit {
  @Input() order!: Order;
  @Input() result!: RegistrationResults;
  @Input() uiConfiguration!: LienDetailsUIConfiguration;
  @Input() showResults: boolean = true;
  
  isAdmin: boolean = false;
  changeText: string[] = [];
  
  constructor(private route: ActivatedRoute) { }
  
  ngOnInit(): void {
    const registryFormID = this.result.registryFormID ?? this.result.registryForm?.id;

    if (registryFormID) {
      const actions = this.order.orderActions?.filter(a => a.registryForm?.id === registryFormID);
      this.changeText = actions?.flatMap(a => a.changeText?.map(c => c.text) ?? []) ?? [];
    } else {
      this.changeText = this.order.orderActions?.flatMap(a => a.changeText?.map(c => c.text) ?? []) ?? [];
    }
  }
}
